import {
  ID,
  EMAIL,
  SHORT_NAME,
  IS_AUTHENTICATED
} from '@/utils/storage'
import axios from 'axios'
import {
  AUTH_CODE_REQUEST,
  AUTH_CODE_SUCCESS,
  AUTH_LOGIN_REQUEST,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGOUT_REQUEST,
  AUTH_LOGOUT_SUCCESS,
  AUTH_ERROR
} from '../actions/auth'

// Initial state
const state = () => ({
  id: parseInt(localStorage.getItem(ID)) || null,
  email: localStorage.getItem(EMAIL) || '',
  short_name: localStorage.getItem(SHORT_NAME) || '',
  is_authenticated: JSON.parse(
    localStorage.getItem(IS_AUTHENTICATED)
  ) || false,
  status: '',
  hasLoadedOnce: false
})

// Getters
const getters = {
  isAuthenticated: state => {
    return state.id && state.email && state.is_authenticated
  },
  authStatus: state => state.status
}

// Actions
const actions = {
  [AUTH_CODE_REQUEST]: ({ commit, dispatch }, email) => {
    return new Promise((resolve, reject) => {
      // Commit email to store so it is available for moving between
      // login steps.
      commit(AUTH_CODE_REQUEST, { email })
      axios({
        method: 'POST',
        url: '/api/auth/email/',
        data: {
          email: email
        }
      })
        .then(response => {
          // Persist email in local storage now we know email is correct.
          localStorage.setItem(EMAIL, email)
          commit(AUTH_CODE_SUCCESS)
          // dispatch(USER_REQUEST)
          resolve(response)
        })
        .catch(err => {
          commit(AUTH_ERROR, err)
          reject(err)
        })
    })
  },
  [AUTH_LOGIN_REQUEST]: ({ commit, dispatch, state }, accessCode) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGIN_REQUEST)
      axios({
        method: 'post',
        url: '/api/auth/login/',
        data: {
          email: state.email,
          token: accessCode
        }
      })
        .then(response => {
          localStorage.setItem(ID, response.data.id)
          localStorage.setItem(SHORT_NAME, response.data.short_name)
          localStorage.setItem(IS_AUTHENTICATED, true)
          commit(
            AUTH_LOGIN_SUCCESS,
            {
              id: parseInt(response.data.id),
              short_name: response.data.short_name
            }
          )
          // dispatch(USER_REQUEST)
          resolve(response)
        })
        .catch(err => {
          commit(AUTH_ERROR, err)
          reject(err)
        })
    })
  },
  [AUTH_LOGOUT_REQUEST]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT_REQUEST)
      axios({
        method: 'post',
        url: '/api/auth/logout/',
        data: {}
      })
        .then(response => {
          // The backed will flush the session and assign user an
          // AnonymousUser, resulting in a new cookie sessionid.
          localStorage.setItem(IS_AUTHENTICATED, false)
          commit(AUTH_LOGOUT_SUCCESS)
          resolve(response)
        })
        .catch(err => {
          // At last log out locally in case have already been logged
          // out server-side.
          localStorage.setItem(IS_AUTHENTICATED, false)
          commit(AUTH_ERROR, err)
          reject(err)
        })
    })
  }
}

// Mutations
const mutations = {
  [AUTH_CODE_REQUEST]: (state, payload) => {
    state.status = 'requesting code'
    state.email = payload.email
  },
  [AUTH_CODE_SUCCESS]: (state) => {
    state.status = 'waiting for code'
  },
  [AUTH_LOGIN_REQUEST]: (state) => {
    state.status = 'logging in'
  },
  [AUTH_LOGIN_SUCCESS]: (state, payload) => {
    console.log(AUTH_LOGIN_SUCCESS, payload)
    state.status = 'success'
    state.id = payload.id
    state.short_name = payload.short_name
    state.is_authenticated = true
    state.hasLoadedOnce = true
  },
  [AUTH_LOGOUT_REQUEST]: (state) => {
    state.status = 'logging out'
  },
  [AUTH_LOGOUT_SUCCESS]: (state) => {
    state.status = 'logged out'
    state.is_authenticated = false
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error'
    state.hasLoadedOnce = true
  }
}

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
}
